import script from "./Worker.vue?vue&type=script&setup=true&lang=js"
export * from "./Worker.vue?vue&type=script&setup=true&lang=js"

import "./Worker.vue?vue&type=style&index=0&id=2c39e7c7&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c39e7c7"]])

export default __exports__